import Vue from "vue";
import languageService from "../../services/language/language";
import { Language } from "../../services/language/entities/language.interface";
import { FixedTerm } from "../../services/language/entities/fixed-term.interface";
import { i18n } from "../../i18n/i18n";
import { LanguageState } from "./states/language.state.interface";

export default {
  namespaced: true,
  state: {
    preferredLanguage: "es",
    languages: [],
    fixedTerms: [],
    totalFixedTerms: 0
  },
  getters: {
    getPreferredLanguage: (state: LanguageState) => state.preferredLanguage,
    getLanguages: (state: LanguageState) => state.languages,
    getFixedTerms: (state: LanguageState) => state.fixedTerms,
    getTotalFixedTerms: (state: LanguageState) => state.totalFixedTerms
  },
  mutations: {
    setPreferredLanguage(state: LanguageState, language: string) {
      Vue.set(state, "preferredLanguage", language);
    },
    setLanguages(state: LanguageState, languages: Array<Language>) {
      Vue.set(state, "languages", languages);
    },
    setFixedTerms(state: LanguageState, fixedTerms: Array<FixedTerm>) {
      Vue.set(state, "fixedTerms", fixedTerms);
    },
    setTotalFixedTerms(state: LanguageState, totalFixedTerms: number) {
      Vue.set(state, "totalFixedTerms", totalFixedTerms);
    }
  },
  actions: {
    getPreferredLanguage: async (context: any, payload: any) => {
      await languageService.getTerms(payload).then((response: any) => {
        if (response.data.obtained) {
          i18n.setLocaleMessage(payload, response.data.terms);
          i18n.locale = payload;
          context.commit("setPreferredLanguage", payload);
          localStorage.setItem("lang", payload);
        }
      });
    },
    getLanguages: async (context: any) => {
      await languageService.getLanguages().then((response: any) => {
        context.commit("setLanguages", response.data.languages);
      });
    },
    getFixedTerms: async (context: any, payload: any) => {
      context.commit("setFixedTerms", []);
      await languageService.getFixedTerms(payload).then((response: any) => {
        context.commit("setTotalFixedTerms", response.data.totalFixedTerms);
        context.commit("setFixedTerms", response.data.terms);
      });
    },
    updateFixedTerm: async (context: any, payload: any) => {
      let updated = false;
      await languageService
        .updateFixedTerm(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await languageService.getFixedTerms(payload).then((response: any) => {
            context.commit("setTotalFixedTerms", response.data.totalFixedTerms);
            context.commit("setFixedTerms", response.data.terms);
          });
        });
      return updated;
    }
  }
};
